import { httpApi, setToken } from './http';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role?: string;
}

export interface AuthResponse {
  success: boolean;
  user?: AuthUser;
  message?: string;
}

function extractToken(payload: unknown): string | undefined {
  const data: any = payload as any;

  const direct =
    data?.token ||
    data?.accessToken ||
    data?.access_token ||
    data?.jwt ||
    data?.jwtToken ||
    data?.jwt_token ||
    data?.adminJwtToken ||
    data?.admin_jwt_token;

  if (typeof direct === 'string' && direct.trim()) return direct;

  const nested =
    data?.data?.token ||
    data?.data?.accessToken ||
    data?.data?.access_token ||
    data?.data?.jwt ||
    data?.data?.jwtToken ||
    data?.data?.jwt_token;

  if (typeof nested === 'string' && nested.trim()) return nested;

  return undefined;
}

export class AuthService {
  static async login(email: string, password: string): Promise<AuthResponse> {
    const response = await httpApi.post<AuthResponse>('/auth/login', { email, password });
    const data = response.data;

    // If backend returns token, persist it so refresh/new tab stays authenticated.
    const maybeToken = extractToken(response.data);
    if (maybeToken) setToken(maybeToken);
    return data;
  }

  static async register(name: string, email: string, password: string): Promise<AuthResponse> {
    const response = await httpApi.post<AuthResponse>('/auth/register', { name, email, password });
    return response.data;
  }

  static async me(): Promise<AuthResponse> {
    const response = await httpApi.get<AuthResponse>('/auth/me');
    return response.data;
  }

  static async logout(): Promise<{ success: boolean }> {
    const response = await httpApi.get<{ success: boolean }>('/auth/logout');
    setToken(null);
    return response.data;
  }
}

export default AuthService;


